import { createReducer } from "@reduxjs/toolkit";

import {
    GET_PAGINATED_GUEST_INSIGHTS,
    GETTING_PAGINATED_GUEST_INSIGHTS_FAILED,
    GETTING_PAGINATED_GUEST_INSIGHTS_SUCCEEDED,
    SET_CURRENT_GUEST_DETAIL,
    UNSET_CURRENT_GUEST_DETAIL,
    GET_CURRENT_GUEST_DETAIL,
    GETTING_CURRENT_GUEST_DETAIL_FAILED,
    GETTING_CURRENT_GUEST_DETAIL_SUCCEEDED,
    UPDATE_TRANSFORMED_GUEST_DETAIL,
    UPDATE_GUEST_INSIGHT_FILTERS,
    UPDATE_PAGINATED_GUEST_INSIGHT_FILTERS,
    RESET_GUEST_INSIGHT_FILTERS
} from "./actions";

const initialState = {
    gettingCurrent: false,
    current: {},
    gettingPaginated: true,
    paginatedList: [],
    error: {},
    transformedGuestDetail: {},
    filters: {
        rowsPerPage: 10,
        pageNo: 0,
        totalCount: 0,
        filterStartDate: null,
        filterEndDate: null,
        filterGuestInfoValues: [],
        filterContactInfoValues: [],
        filterConsentValues: [],
        filterDateValues: []
    }
};

export default createReducer(initialState, {
    [GET_PAGINATED_GUEST_INSIGHTS]: state => {
        state.gettingPaginated = true;
        state.error = {};
    },
    [GETTING_PAGINATED_GUEST_INSIGHTS_SUCCEEDED]: (state, action) => {
        state.gettingPaginated = false;
        state.paginatedList = action?.payload.map(guestInsight => ({
            ...guestInsight
        }));
        return state;
    },
    [GETTING_PAGINATED_GUEST_INSIGHTS_FAILED]: (state, action) => {
        state.gettingPaginated = false;
        state.error = {
            message: action.payload.message,
            raw: action.payload
        };
        return state;
    },
    [SET_CURRENT_GUEST_DETAIL]: (state, action) => {
        state.current = {
            ...action.payload
        };
        state.gettingCurrent = false;
        return state;
    },
    [UNSET_CURRENT_GUEST_DETAIL]: state => {
        state.current = {};
        state.gettingCurrent = true;
        return state;
    },
    [GET_CURRENT_GUEST_DETAIL]: state => {
        state.gettingCurrent = true;
        state.error = {};
        state.current = {};
        return state;
    },
    [GETTING_CURRENT_GUEST_DETAIL_SUCCEEDED]: (state, action) => {
        state.gettingCurrent = false;
        state.error = {};
        state.current = {
            ...action.payload
        };
        return state;
    },
    [GETTING_CURRENT_GUEST_DETAIL_FAILED]: (state, action) => {
        state.gettingCurrent = false;
        state.error = {
            message: action.payload.message,
            raw: action.payload
        };
        state.current = {};
        return state;
    },
    [UPDATE_TRANSFORMED_GUEST_DETAIL]: (state, action) => {
        state.transformedGuestDetail = {
            ...action.payload
        }
        return state;
    },
    [UPDATE_GUEST_INSIGHT_FILTERS]: (state, action) => {
        state.filters = {
            ...state.filters,
            ...action.payload
        }
        return state;
    },
    [UPDATE_PAGINATED_GUEST_INSIGHT_FILTERS]: (state, action) => {
        state.gettingPaginated = true;
        state.filters = {
            ...state.filters,
            ...action.payload
        }
        return state;
    },
    [RESET_GUEST_INSIGHT_FILTERS]: state => {
        state.gettingPaginated = true;
        state.filters = { ...initialState.filters }
        return state;
    },
});